import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarProvider,
} from "@/components/ui/sidebar";
import {
  Users,
  Palette,
  CreditCard,
  FileText,
  Settings,
  MessageSquare,
  ChevronRight,
  MessageSquarePlus,
} from "lucide-react";

const adminItems = [
  {
    title: "Gerenciamento de Usuários",
    icon: Users,
    path: "/admin/users",
    description: "Gerenciar usuários e permissões"
  },
  {
    title: "Mensagens WhatsApp",
    icon: MessageSquare,
    path: "/admin/whatsapp",
    description: "Enviar mensagens WhatsApp"
  },
  {
    title: "Feedbacks & Bugs",
    icon: MessageSquarePlus,
    path: "/admin/feedbacks",
    description: "Gerenciar feedbacks e bugs"
  },
  {
    title: "Paletas de Cores",
    icon: Palette,
    path: "/admin/color-palettes",
    description: "Configurar temas do sistema"
  },
  {
    title: "Verificação de Pagamentos",
    icon: CreditCard,
    path: "/admin/payments",
    description: "Verificar e gerenciar pagamentos"
  },
  {
    title: "Assinaturas",
    icon: FileText,
    path: "/admin/subscriptions",
    description: "Gerenciar planos de assinatura"
  },
  {
    title: "Configurações",
    icon: Settings,
    path: "/admin/settings",
    description: "Configurações administrativas"
  },
];

export function AdminNavigation() {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <Sidebar variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <Settings className="size-4" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">monelab Admin</span>
                <span className="truncate text-xs">Painel Administrativo</span>
              </div>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu>
          {adminItems.map((item) => (
            <SidebarMenuItem key={item.path}>
              <SidebarMenuButton
                asChild
                isActive={isActive(item.path)}
                tooltip={item.title}
              >
                <Link to={item.path}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  );
}
